import classNames from 'classnames';
import { TBackgroundDataItem, canvasBackgroundContext } from '../../../context/canvasBackgroundContext';
import styles from './CollectionsElement.module.css';
import { useContext, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { collectionsContext } from "../../../context/collectionsContext";
import { canvasTextureContext } from "../../../context/canvasTextureContext";

export type TCollectionsDataItem = {
    id: number;
    img: string;
    name: string;
};

interface ICollections {
    sectionName: string;
    sectionId: number;
    items: TCollectionsDataItem[];
}
export const CollectionsElement = (collectionsElementData: ICollections) => {
    const arItems = Object.values(collectionsElementData.items);
    const { collectionsData, setCollectionsData } = useContext(collectionsContext);
    // const { imgData } = useContext(canvasTextureContext);

    const [isLocked, setIsLocked] = useState(false);

    const handleChooseCollection = (itemId: number) => {
        if(isLocked) return;
        setCollectionsData({
            items: collectionsData.items,
            elementId: itemId,
            sectionId: collectionsElementData.sectionId,
            prevSectionId: collectionsData.sectionId,
        });

        const newSectionData = {
            sectionId: collectionsElementData.sectionId,
            elementId: itemId,
            texture: null
        }

        localStorage.setItem(`sectionData_${collectionsElementData.sectionId}`, JSON.stringify(newSectionData));

        setIsLocked(true);
        setTimeout(() => {
            setIsLocked(false);
        }, 1000);
    }

    return (
        <div>
            <Box p="10px 5px">
                {/*<Typography fontWeight="bold" fontSize={'20px'}>{groupName}</Typography>*/}
                <Typography fontWeight="bold">{collectionsElementData.sectionName}</Typography>
                <Typography fontSize="small" sx={{ color: 'var(--light-font-color)' }}>
                    {/*{price} р./м2*/}
                </Typography>
            </Box>

            <Grid display="grid" gridTemplateColumns="repeat(4, 1fr)">
                {arItems.map(item => {
                    const curSectionData = JSON.parse(localStorage!.getItem(`sectionData_${collectionsElementData.sectionId}`)!);
                    const isActive = curSectionData && curSectionData.elementId == item.id;
                    return (
                        <div
                            key={item.name}
                            className={classNames(styles.container, styles.textureContainer) + ' js-constructor-item-wrapper'}
                            data-elementid={item.id}
                            onClick={() => handleChooseCollection(Number(item.id))}
                        >
                            <div className={classNames(styles.imageWrap, isActive && styles.imageWrapSelected, isLocked && styles.locked)}>
                                <div className={classNames(styles.imageContainer, styles.textureImageContainer)}>
                                    <img src={'https://fresq.ru/'+item.img} alt={item.name} className={classNames('texture_image')}/>
                                    <Box
                                        position="relative"
                                        zIndex="1"
                                        fontSize=".65rem"
                                        sx={{
                                            color: 'var(--white)',
                                            background: 'var(--black)',
                                            position: 'absolute',
                                            left: '0',
                                            bottom: '0',
                                            p: '0 3px'
                                        }}
                                    >
                                        {/*<div className={classNames(styles.nameContainer)}>{item.name.replace(' ', '').substring(0, 5)}</div>*/}
                                        <div className={classNames(styles.nameContainer)}>{item.name}</div>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Grid>
        </div>
    );
};
